import { formatCents } from '@insify/ui-utils';
import { useTranslation } from 'react-i18next';

import { useContent } from '../../hooks/useContent';

import type { PastClaimsContent } from '@insify/funnel-components/src/pages/PastClaims';

const validation = {
  minClaimAmount: 100,
  maxClaimAmount: 9999999900,
};

export const usePastClaimsContent = (): Pick<PastClaimsContent, 'richContent' | 'translations'> => {
  const { t } = useTranslation(['funnel', 'validation', 'common']);
  const { pastClaimsOverview, pastClaimsThreshold: thresholdContent, pastClaimsForm } = useContent() || {};

  return {
    richContent: {
      confirm: thresholdContent,
      overview: pastClaimsOverview,
      form: pastClaimsForm,
    },
    translations: {
      previous: t('common:back'),
      overviewYes: t('common:yes'),
      overviewNo: t('common:no'),
      overviewContinue: t('common:continue'),
      formSubmit: t('common:continue'),
      overviewEdit: t('funnel:past_claims_overview_edit'),
      overviewAddNewButtonCopy: t('funnel:past_claims_overview_add_new_button_copy'),
      overviewYearLabel: t('funnel:past_claims_overview_year_label'),
      overviewCoverageLabel: t('funnel:past_claims_overview_coverage_label'),
      overviewAmountLabel: t('funnel:past_claims_overview_amount_label'),
      formYearLabel: t('funnel:past_claims_form_year_label'),
      formYearPlaceholder: t('funnel:past_claims_form_year_placeholder'),
      formCoverageLabel: t('funnel:past_claims_form_coverage_label'),
      formCoveragePlaceholder: t('funnel:past_claims_form_coverage_placeholder'),
      formAmountLabel: t('funnel:past_claims_form_amount_label'),
      validationYearRequired: t('validation:past_claims_year_required'),
      validationCoverageRequired: t('validation:past_claims_coverage_required'),
      validationNumberTooLow: t('validation:past_claims_number_too_low', {
        min: formatCents(`${validation.minClaimAmount}`),
      }),
      validationNumberTooHigh: t('validation:past_claims_number_too_high', {
        max: formatCents(`${validation.maxClaimAmount}`),
      }),
      validationAmountRequired: t('validation:past_claims_amount_required'),
      currency: t('common:currency'),
    },
  };
};
